module.exports = __webpack_public_path__ + "static/media/imgCS.e8c9d78d.png";